import React from "react";
import '../FirstMain/FirstMain.scss';

import MainData from "./MainData/MainData";

import Authorization from "../Authorization/Authorization";


const FirstMain = (props) => {
  const {dispatch} = props;

const renderMainViewBeforeRegistration = () => {
  return (
    
  <div className="FirstMain">
    <Authorization
    dispatch={dispatch}
    userData={props.userData}
    />
    {!props.userData.isActivated && props.userData.id ? renderActivationMessage(): null}
  </div>

  );
};
const renderMainViewAfterRegistration = () => {
  return (
  <div className="FirstMain">
    <Authorization
    dispatch={dispatch}
    userData={props.userData}
    />
    <MainData 
    dispatch={dispatch}
    userData={props.userData}
    getData={props.getData}
    />
 </div>

  );
};


// RENDER ACTIVATION ALERT
const renderActivationMessage = () => {
  return (
    <div className="MainData" id="ActivationMessage">
      <h2>Аккаунт не активирован.</h2>

    </div>
  )
}
//RENDER


  if (props.userData.openMainData === true && props.userData.isActivated === true ) {
      console.log(props.userData.openMainData);
      console.log(props.userData.isActivated );
      return renderMainViewAfterRegistration();
  }
  
      return renderMainViewBeforeRegistration();

}
  
  export default FirstMain;